import { axiosWithAuth } from "helpers";
import { MerchantType } from "types/merchantV2";

export const merchantV2Service = {
	getMerchantLookup,
	getMerchant,
	editMerchant,
};

const API_URL = process.env.REACT_APP_API_URL;

function getMerchant({ id }: { id: number }) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/v2/merchants/${id}`,
	};

	return axiosWithAuth(options);
}

function editMerchant(data: MerchantType) {
	const { id, ...values } = data;
	const options = {
		method: "PUT",
		data: values,
		url: `${API_URL}/api/v2/merchants/${data?.id}`,
	};

	return axiosWithAuth(options);
}

function getMerchantLookup({ page, pageSize = 20, searchFor }) {
	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: pageSize,
			search_for: searchFor,
		},
		url: `${API_URL}/api/v2/merchants/lookup`,
	};

	return axiosWithAuth(options);
}
